import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, EMPTY, Subject } from 'rxjs';
import { menuInterface } from '../../../Model/Administracion/menu.Interface';
import { AdministracionService } from '../../../services/Seguridad/administracion.service';
import { tap, catchError, finalize } from 'rxjs/operators';
import { DataApi } from 'app/Model/dataApi';
import { HttpErrorResponse } from '@angular/common/http';
import { MensajesHttpService } from '../../../utils/mensajesHttp/mensajes-http.service';
import { ToastrServiceLocal } from '../../../services/toast/toastr.service';
import { StoreService } from 'app/store/store.service';
import { State } from 'app/store/reducers';
import * as menuActions from '../../../store/actions/Administracion/menus.actions';
import { perfilInterface } from 'app/Model/Administracion/perfil.Interface';
import { PerfilesFacadeService } from '../perfiles/perfiles-facade.service';
import { DataApiService } from 'app/services/data-api.service';

@Injectable({
  providedIn: 'root'
})
export class MenusFacadeService {

  constructor(private administracionService: AdministracionService, private _mensajesHttp: MensajesHttpService,
    private _toast: ToastrServiceLocal, private _store: StoreService<State>, private _dataApi: DataApiService) { }


  //Respuesta Acción
  private Action$ = new Subject<any>();
  public responseAction$: Observable<any> = this.Action$.asObservable();

  private Menus$ = new BehaviorSubject<menuInterface[]>([]);
  public responseMenus$: Observable<menuInterface[]> = this.Menus$.asObservable();

  private Cargando$ = new BehaviorSubject<boolean>(false);
  public responseCargando$: Observable<boolean> = this.Cargando$.asObservable();

  private Error$ = new BehaviorSubject<any>({ hasError: true, recurso: '', messageError: '', errors: [] });
  public responseError$: Observable<any> = this.Error$.asObservable();

  public itemMenus:any;
  public nombreMenu: string = '';

  public previousUrl: string = '';
  public currentUrl: string = '';

  public menusHijos: boolean = false;
  public accionRealizada: boolean = false;

  public idMenuPadre: number = 0;

  MostrarMenu(params: any) {
    this.Menus$.next([]);
    this.menusHijos = false;
    this.Cargando$.next(true);
    this.idMenuPadre = 0;
    const request$ = this.administracionService.GetMenu('admin/v1/monstrarMenuAll', params).pipe(
      tap((result: DataApi | any) => {
        // console.log(this.accionRealizada);

        // if (this.accionRealizada == true) {
        //   this._store.dispatch(new menuActions.GetMenus(result));
        // }
        this.Menus$.next(result);
        this.accionRealizada = false;
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this.Menus$.next([]);
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los menus', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'GET', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al mostrar los menus'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }
  


  // viewMenus( params): Observable<any> {
  //   // this.Cargando$.next(true);  
  //   const request$ = this._dataApi.GetDataApi(`seguridad/viewMenus`, params).pipe(
  //       tap((result: DataApi | any) => {
  //           this.Menus$.next(result.data.Table0); 
  //           // this.Cargando$.next(false); 
  //       }),
  //       catchError((error: HttpErrorResponse) => {
  //           console.error(error);
  //           this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al mostrar las promociones', '');
  //           this.Cargando$.next(false); // Indica que terminó con error
  //           this.Error$.next({
  //               hasError: true,
  //               recurso: 'GET',
  //               messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrió un error al mostrar las promociones'),
  //               errors: []
  //           });
  //           return EMPTY;
  //       }),
  //       finalize(() => {
  //            this.Cargando$.next(false);
  //       })
  //   );
  
  //   return request$; // Devuelve el observable
  // }

  
  viewMenus(params: any){

  this.Cargando$.next(true);
  this.menusHijos = false;
  this.idMenuPadre = 0;
  const request$ = this._dataApi.GetDataApi(`seguridad/viewMenus`, params).pipe(
    tap((result: DataApi | any) => {

      if( result.hasError === false ){
        this.Menus$.next(result.data.Table0);
      }

      this.Cargando$.next(false);
    }),
    catchError((error: HttpErrorResponse) => {

      this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los postgrados', '');
      this.Cargando$.next(false);

      return EMPTY;
    })
  );

  return request$.subscribe();

}


insertMenuPadre(params: any) {
  this.Action$.next({});
  this.Cargando$.next(true);
  this._toast.mensajeLoading('Cargando', 'Procesando la información');

  const request$ = this._dataApi.PostDataApi(`seguridad/insertMenuPadre`, params).pipe(
    tap((result: DataApi | any) => {
      console.log(result);
      this._toast.clearToasts();
      this.Menus$.next(result.data.Table0);
      this.Cargando$.next(false);
      this.Action$.next(result);
    }),
    catchError((error: HttpErrorResponse) => {
      console.log(error);
      this._toast.clearToasts();
      this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrió un error al guardar la solicitud', '');
      this.Cargando$.next(false);
      return EMPTY;
    })
  );
  return request$;  
}
  
  // viewMenus(params: any) {
  //   // this.Menus$.next([]);
  //   // this.menusHijos = false;
  //   this.Cargando$.next(true);
  //   this.idMenuPadre = 0;
  //   const request$ = this.administracionService.GetMenu('seguridad/viewMenus', params).pipe(
  //     tap((result: DataApi | any) => {
  //       this.Menus$.next(result.data.Table0); // Actualiza los datos

  //       console.log(this.accionRealizada);

  //       // if (this.accionRealizada == true) {
  //       //   this._store.dispatch(new menuActions.GetMenus(result));
  //       // }
  //       this.Menus$.next(result);
  //       this.accionRealizada = false;
  //       // this.Cargando$.next(false);
  //     }),
  //     catchError((error: HttpErrorResponse) => {
  //       this.Menus$.next([]);
  //       this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los menus', '');
  //       this.Cargando$.next(false);
  //       this.Error$.next({ hasError: true, recurso: 'GET', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al mostrar los menus'), errors: [] });
  //       return EMPTY;
  //     })
  //   );

  //   return request$.subscribe();
  // }




  MostrarMenuUsuario(params: any) {
    this.Menus$.next([]);
    this.Cargando$.next(true);
    const request$ = this.administracionService.GetMenu('admin/v1/monstrarMenu', params).pipe(
      tap((result: DataApi | any) => {
        this.Menus$.next(result);
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this.Menus$.next([]);
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los menus', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'GET', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al mostrar los menus'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  MostrarMenuByFilter(params: any) {
    this.menusHijos = false;
    this.Cargando$.next(true);
    this.idMenuPadre = 0;
    const request$ = this.administracionService.GetMenu('admin/v1/monstrarMenuFilter', params).pipe(
      tap((result: DataApi | any) => {
        this.Menus$.next([result]);

        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this.Menus$.next([]);
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los menus', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'GET', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al mostrar los menus'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  NuevoMenu(params: any) {
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');
    const request$ = this.administracionService.PostMenu('admin/v1/menu', params).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();
        this.Action$.next(result);
        this.accionRealizada = true;
        this._toast.mensajeSuccess('Se creó con éxito el menu', '');
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al insertar el menu', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al insertar el menu'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  EditarMenu(params: any) {
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');
    const request$ = this.administracionService.PutMenu('admin/v1/menu', params).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();

        this.Action$.next(result);
        this.accionRealizada = true;
        this._toast.mensajeSuccess('Se edito con exito el menu', '');
        this.Cargando$.next(false);
      }),
      catchError((err: HttpErrorResponse) => {
        this._toast.clearToasts();
        this.Action$.next(err.error);
        this._mensajesHttp.mostrarErrorHttp(err, 'Ocurrio un error al insertar el menu', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(err, 'Ocurrio un error al insertar el menu'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  EliminarMenu(params: any) {
    this.Cargando$.next(true);

    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    const request$ = this.administracionService.DeleteMenu('admin/v1/menu', params).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();
        console.log(result);
        // if(result.hasError){
        //   this._toast.mensajeError(`${result.data.Table0[0]}`, '');
        // }
        this.Action$.next(result);
        this.accionRealizada = true;
        this._toast.mensajeSuccess('Se elimino con exito el menu', '');
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al eliminar el menu', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al eliminar el menu'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  EliminarMenuUsuario(params: any) {
    this.Cargando$.next(true);

    this._toast.mensajeLoading('Cargando', 'Procesando la información');

    const request$ = this.administracionService.DeleteMenu('admin/v1/usuario/menu', params).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();
        this.Action$.next(result);
        this._toast.mensajeSuccess('Se quito con exito el menu', '');
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al quitar el menu', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al quito el menu'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  EliminarPerfilUsuario(params: any) {
    this.Cargando$.next(true);
    this._toast.mensajeLoading('Cargando', 'Procesando la información');
    const request$ = this.administracionService.DeleteMenu('admin/v1/perfil/menu', params).pipe(
      tap((result: DataApi | any) => {
        this._toast.clearToasts();

        this.Action$.next(result);
        this._toast.mensajeSuccess('Se quito con exito el menu', '');
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();

        this.Action$.next({});
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al quitar el menu', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al quito el menu'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  rutaPrevia() {
    return this.previousUrl;
  }

  subMenuConstruir(idMenuPadre) {
    this.Cargando$.next(true);
    this.idMenuPadre = idMenuPadre;
    let arrayMenus: menuInterface[];
    this.Menus$.subscribe((result) => {
      for (let i = 0; i < result.length; i++) {
        if (result[i].idMenu === idMenuPadre) {
          arrayMenus = result[i].hijos;
        }
      }
    });
    this.Cargando$.next(false);
    this.Menus$.next(arrayMenus);
    this.menusHijos = true;
    const mens =    this.Menus$.next(arrayMenus);
const menuhijo=     this.menusHijos = true;

    console.log(mens,menuhijo)
  }

  MostrarPerfilesMenu(params: any) {
    this.Menus$.next([]);
    this.menusHijos = false;
    this.Cargando$.next(true);
    this.idMenuPadre = 0;
    const request$ = this.administracionService.GetMenu('admin/v1/perfilMostrar', params).pipe(
      tap((result: DataApi | any) => {
        console.log(result);
        this.Menus$.next(result);
        if (this.accionRealizada == true) {
          this._store.dispatch(new menuActions.GetMenus(result));
        }
        this.accionRealizada = false;
        this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
        this.Menus$.next([]);
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error al mostrar los menus', '');
        this.Cargando$.next(false);
        this.Error$.next({ hasError: true, recurso: 'GET', messageError: this._mensajesHttp.mostrarErrorHttpString(error, 'Ocurrio un error al mostrar los menus'), errors: [] });
        return EMPTY;
      })
    );

    return request$.subscribe();
  }

  menuItem(item){
    this.itemMenus = item;
  }

  recargarMenu(){
    if(this.idMenuPadre == 0){
      this.MostrarMenu({});
    }
    else{
      this.subMenuConstruir(this.idMenuPadre);
    }
  }


}
